import React from "react";

const Store = (props) => (
  <div className="sideNavSection">
    <div className="feature">
      <h3>New on Dream Chimney</h3>
      <p style={{ fontSize: 14 }}>RIK "Matter of Time"</p>
      <a href="https://dreamchimney.bandcamp.com/album/matter-of-time" target="_blank">
        <img src="https://www.dreamchimney.com/releases/DC010/kba-dc010-cd-tape.jpg" className="img-responsive center-block" alt="Matter of Time" />
        <div className="featureTextFooter">
          <strong>Available on CD &amp; Tape &raquo;</strong>
        </div>
      </a>
    </div>
  </div>
);

export default Store;
